export const DISTANCE_UNITS = {
  mi: 'mi',
  km: 'km',
};

export const SYSTEMS = {
  imperial: 'imperial',
  metric: 'metric',
};
